import AnalyticsFiltersNew from './index-new';
import V2AnalyticsFilters from './filters-v2';


export default AnalyticsFiltersNew;
export {V2AnalyticsFilters};
